import Threads from "discourse/plugins/chat/discourse/components/chat/routes/threads";

export default <template><Threads /></template>
